import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { API_URL } from '../config';

const BitcoinRainbowChartPage = () => {
  const [btcData, setBtcData] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/btc-price`);
        setBtcData(res.data);
      } catch (e) { console.error('Failed to fetch BTC price:', e); }
    };
    fetchPrice();
    const interval = setInterval(fetchPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  const formatNum = (n) => {
    if (!n) return '$0';
    if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
    if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
    if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
    return `$${n.toLocaleString()}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-20 pb-12">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header + BTC Price */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div>
            <h1 className="font-heading font-black text-3xl uppercase text-white mb-2" data-testid="rainbow-chart-title">
              Bitcoin Rainbow Chart
            </h1>
            <p className="text-[#8892B0]">
              Logarithmic regression + live BTC price
            </p>
          </div>
          {btcData && btcData.price > 0 && (
            <div className="bg-[#131313] border border-white/5 px-6 py-3 flex items-center gap-6" data-testid="btc-price-card">
              <div>
                <p className="text-xs text-[#5C6B82] uppercase tracking-wider">BTC/USD</p>
                <p className="text-2xl font-black text-white">${btcData.price.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-xs text-[#5C6B82] uppercase tracking-wider">24h</p>
                <p className={`text-lg font-bold ${btcData.change_24h >= 0 ? 'text-[#34C759]' : 'text-[#FF3B30]'}`}>
                  {btcData.change_24h >= 0 ? '+' : ''}{btcData.change_24h?.toFixed(2)}%
                </p>
              </div>
              <div className="hidden sm:block">
                <p className="text-xs text-[#5C6B82] uppercase tracking-wider">Market Cap</p>
                <p className="text-sm font-bold text-[#8892B0]">{formatNum(btcData.market_cap)}</p>
              </div>
              <div className="hidden sm:block">
                <p className="text-xs text-[#5C6B82] uppercase tracking-wider">24h Volume</p>
                <p className="text-sm font-bold text-[#8892B0]">{formatNum(btcData.volume_24h)}</p>
              </div>
            </div>
          )}
        </div>

        {/* Rainbow Chart Embed */}
        <div
          className="bg-[#131313] border border-white/5 overflow-hidden"
          style={{ height: '65vh', minHeight: '450px' }}
          data-testid="rainbow-chart-container"
        >
          <iframe
            src="https://www.blockchaincenter.net/en/bitcoin-rainbow-chart/"
            title="Bitcoin Rainbow Chart"
            style={{ width: '100%', height: '100%', border: 'none' }}
            allow="autoplay; encrypted-media"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            data-testid="rainbow-chart-iframe"
          />
        </div>

        <p className="mt-4 text-xs text-[#5C6B82] text-center">
          Rainbow chart by BlockchainCenter.net &middot; Price from CoinGecko. Not financial advice.
        </p>
      </div>
    </div>
  );
};

export default BitcoinRainbowChartPage;
